module.exports = __webpack_public_path__ + "static/partners-b470e68eba0f0ec91fb86a049cd473ff.png";